import React from "react";
import img from "../../assets/images/unity_loading.jpg";
import img2 from "../../assets/images/menu-ic.png";

import Table from "../../components/table";
const Tournaments = () => {
  return (
    <div className="bg-black h-[auto]">
      <div className="text-white pt-[150px] mb-[50px] text-center text-[70px]">
        Nothing
      </div>
      <div className="w-[80%] mx-auto">
        <img width="100%" src={img} alt="" />
      </div>
      <div className="flex justify-center mt-[40px]">
        <button className="flex items-center w-[200px] justify-between px-4 py-2 text-white hover:text-[red] focus:outline-none">
          <span>Now Fighting</span>
          <img src={img2} alt="" />
        </button>
        <button className="flex items-center w-[200px] justify-between px-4 py-2 text-white hover:text-[red] focus:outline-none">
          <span>Open Tournaments</span>
          <img src={img2} alt="" />
        </button>
        <button className="flex items-center w-[200px] justify-between px-4 py-2 text-white hover:text-[red] focus:outline-none">
          <span>Results</span>
          <img src={img2} alt="" />
        </button>
      </div>
      <Table />

      <div className="text-white text-center mt-[100px] pb-[100px]">
        Due to fluctuations in the price of ETH, the above USD values may change
        before the Tournament commences
      </div>
    </div>
  );
};

export default Tournaments;
